'use client';

import { ReactNode, createContext, useContext } from 'react';
import { Config } from '@/schema/config-schema';

const WebsiteConfigContext = createContext<Config>({} as Config);

type Props = {
    website: Config;
    children?: ReactNode;
};

export const WebsiteConfigProvider = ({ website, children }: Props) => {
    return <WebsiteConfigContext.Provider value={website}>{children}</WebsiteConfigContext.Provider>;
};

export const useWebsiteConfig = () => useContext(WebsiteConfigContext);
